export default __webpack_public_path__ + "static/media/casaduana_LogoHeader.4b6a6ea9.svg";